/** @format */

import React, { useState, useEffect } from "react";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-modal-video/css/modal-video.min.css";
import "react-multi-carousel/lib/styles.css";
import themeData from "./data/themeData";
import ThemeModeContext from "./context/ThemeModeContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import SettingContext from "./context/SettingsContext";
import { Route, Routes } from "react-router-dom";
import Loader from "./components/Loader";
import WebsiteThemeContext from "./context/WebsiteThemeContext";
import Login from "./components/Authentication/Login";
import ForgotPassword from "./components/Authentication/ForgotPassword";
import { useQuery } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";

import { get } from "./services/apiMethods";
import { PRIVATE_URLS, PUBLIC_URLS } from "./services/urlConstants";
import SplashNewsHorizontal from "./theme-one/components/SpalshNews/SpalshNewsHorizontal";
import SpalshNewsPopup from "./theme-one/components/SpalshNews/SpalshNewsPopup";
import UserTypeContext from "./context/UserTypeContext";
import ExamQuestion from "./components/ExamConduct/ExamQuestion";
import ExamVenue from "./components/ExamConduct/ExamVenue";
import StudetCourseContent from "./pages/StudentDashboard/StudetCourseContent";

// const Web1 = React.lazy(() => import("./components/WebsiteTheme1"));
// const Web2 = React.lazy(() => import("./components/WebsiteTheme2"));
// const Web3 = React.lazy(() => import("./components/WebsiteTheme3"));
const Web3 = React.lazy(() => import("./components/WebsiteTheme4"));

const EmployeeDashBoard = React.lazy(() => import("./components/NavDrawer"));
const StudentDashBoard = React.lazy(() =>
  import("./components/NavDrawerStudent")
);

const THEME_SELECT = {
  1: <Web3 />,
  // 2: <Web2 />,
  // 3: <Web3 />,
};

function App() {
  const [selectedTheme, setSelectedTheme] = useState(1);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [userType, setUserType] = useState("employee");

  const [settings, setSettings] = useState([]);
  const [selectedSetting, setSelectedSetting] = useState({
    name: "ABC School",
  });

  const [popupData, setPopupData] = useState({
    open: false,
    data: null,
  });
  const [horizontalData, setHorizontalData] = useState([]);
  const handleClosePopup = () => setPopupData({ open: false, data: null });

  useEffect(() => {
    let userType = window.localStorage.getItem(process.env.REACT_APP_USER_TYPE);
    if (userType) {
      setUserType(userType);
    }
  }, []);

  const getSplashNews = async () => {
    try {
      const { data } = await get(PRIVATE_URLS.splashNews.listPublic, {
        params: {
          schoolId: selectedSetting._id,
        },
      });
      setHorizontalData([]);
      setPopupData({
        open: false,
        data: null,
      });

      if (data.result.length) {
        let allSplashNews = data.result;
        setHorizontalData(
          allSplashNews.filter((s) => s.type !== "Popup" && s.enabled === true)
        );
        setPopupData({
          open: false,
          data: allSplashNews.filter(
            (s) => s.type === "Popup" && s.enabled === true
          )[0],
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedSetting && selectedSetting._id) {
      getSplashNews();
    }
  }, [selectedSetting]);

  useEffect(() => {
    if (popupData.data) {
      setPopupData({ ...popupData, open: true });
    }
  }, [popupData.data]);

  useEffect(() => {
    if (selectedSetting._id) {
      setSelectedTheme(selectedSetting?.selectedTheme);
    } else {
      setSelectedTheme(1);
    }
  }, [selectedSetting]);

  useEffect(() => {
    let isDark = window.localStorage.getItem("isDarkMode");

    setIsDarkMode(isDark === "true" ? true : false);
  }, [window.localStorage.getItem("isDarkMode")]);

  const theme = createTheme({
    palette: isDarkMode ? themeData.darkPalette : themeData.lightPalette,
    shape: {
      borderRadius: 5,
    },
    typography: {
      allVariants: {
        color: isDarkMode ? "white" : "black",
        fontSize: "14px",
      },
    },

    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            borderRadius: 5,
            input: {
              "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px rgba(0, 0, 0, 0) inset",
                boxShadow: "0 0 0 100px rgba(0, 0, 0, 0) inset",
                backgroundColor: "transparent !important",
                WebkitTextFillColor: isDarkMode
                  ? "#fff !important"
                  : "#000 !important", // Ensure text color is set
                transition: "background-color 5000s ease-in-out 0s",
              },
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          containedPrimary: {},
          sizeSmall: {
            fontSize: "12px",
          },
          root: {
            boxShadow: "none",
            borderRadius: 5,
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            "&.Mui-selected": {
              backgroundColor: isDarkMode ? "#4f4f4f" : "#e8eaed",
            },
          },
        },
      },
      MuiIcon: {
        defaultProps: {
          color: "primary",
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            height: "40px",
          },
        },
      },

      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#fff",
          },
          root: {
            padding: "4px",
            height: "50px",
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            borderRadius: 5,

            height: "40px",
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
          },
        },
      },

      MuiGrid: {
        styleOverrides: {
          root: {
            paddingTop: 0,
          },
        },
      },
    },
  });

  const webTheme = createTheme({
    palette: themeData.lightPalette,
    shape: {
      borderRadius: 5,
    },
    typography: {
      allVariants: {
        // color: isDarkMode ? "white" : "black",
        fontSize: "14px",
      },
    },

    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            borderRadius: 5,
            input: {
              "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px rgba(0, 0, 0, 0) inset",
                boxShadow: "0 0 0 100px rgba(0, 0, 0, 0) inset",
                backgroundColor: "transparent !important",
                WebkitTextFillColor: "#000 !important", // Ensure text color is set
                transition: "background-color 5000s ease-in-out 0s",
              },
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            boxShadow: "none",
            borderRadius: 5,
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 5,

            "&.Mui-selected": {
              backgroundColor: isDarkMode ? "#4f4f4f" : "#e8eaed",
            },
          },
        },
      },
      MuiIcon: {
        defaultProps: {
          color: "primary",
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            height: "40px",
          },
        },
      },

      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#fff",
          },
          root: {
            padding: "8px",
            height: "40px",
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            borderRadius: 5,
            height: "40px",
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
          },
        },
      },

      MuiGrid: {
        styleOverrides: {
          root: {
            paddingTop: 0,
          },
        },
      },
    },
  });

  // get schools list
  const getAllSchools = async () => {
    const { data } = await get(PUBLIC_URLS.school.getSchools);
    return data.result;
  };

  const { data, isLoading } = useQuery({
    queryKey: ["publicSchoolList"],
    queryFn: getAllSchools,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data) {
      setSettings(data);
      if (data.length) {
        setSelectedSetting(data[0]);
      }
    }
  }, [data]);

  if (isLoading) return <Loader />;

  return (
    <SettingContext.Provider
      value={{
        settings,
        setSettings,
        selectedSetting,
        setSelectedSetting,
      }}>
      <UserTypeContext.Provider value={{ userType, setUserType }}>
        <WebsiteThemeContext.Provider
          value={{ selectedTheme, setSelectedTheme }}>
          <ThemeProvider theme={webTheme}>
            <SpalshNewsPopup
              open={popupData.open}
              sharedData={popupData.data}
              handleClose={handleClosePopup}
            />
            {horizontalData.length ? (
              <SplashNewsHorizontal
                horizontalData={horizontalData}
                selectedTheme={selectedTheme}
              />
            ) : null}
            <Routes>
              <Route
                path="/*"
                element={
                  <React.Suspense fallback={<Loader />}>
                    {THEME_SELECT[selectedTheme]}
                  </React.Suspense>
                }
              />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/pre-admission/exam-conduct/:id"
                element={<ExamQuestion />}
              />
              <Route
                path="/details/pre-admission/:id"
                element={<ExamVenue />}
              />
              <Route
                path="student_course_content/:id"
                element={<StudetCourseContent />}
              />
            </Routes>
          </ThemeProvider>

          <ThemeModeContext.Provider value={{ isDarkMode, setIsDarkMode }}>
            <ThemeProvider theme={theme}>
              <Routes>
                <Route
                  path="/sch/*"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      {userType === "employee" ? (
                        <EmployeeDashBoard />
                      ) : (
                        <StudentDashBoard />
                      )}
                    </React.Suspense>
                  }
                />
              </Routes>
            </ThemeProvider>
          </ThemeModeContext.Provider>
        </WebsiteThemeContext.Provider>
        <ToastContainer />
      </UserTypeContext.Provider>
    </SettingContext.Provider>
  );
}

export default App;
